module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-08-7cead60a6beee9a8fdf26b42f031b2bb.jpg";